import { IntegrationApi } from '@alliander-fe/api';
import { useQuery } from '@tanstack/react-query';
import { rewriteEnergyType, setReplaceText } from 'src/utils';
import { OutageView } from './_View';
import { OutageNotFound } from './_OutageNotFound';
import { Props } from '.';

type SpecificProps = {
  postalCode: string;
  houseNumber: string;
  addition: string;
} & Props;

export function OutageSpecific(props: SpecificProps) {
  const { postalCode, houseNumber, addition } = props;

  const {
    data: specificOutageData,
    isLoading: specificOutageLoading,
    isFetched: specificOutageIsFetched,
  } = useQuery({
    queryKey: ['specificOutage', postalCode, houseNumber, addition],
    queryFn: () =>
      IntegrationApi.serviceAvailabilityEndpointsGetServiceAvailabilityDetails({
        postalCode,
        houseNumber: Number(houseNumber),
        addition: addition,
      }),
  });

  const referenceNumber = specificOutageData?.outageNumber?.toString() || '';

  const {
    data: outageData,
    isLoading: outageLoading,
    isSuccess: outageIsSuccess,
  } = useQuery({
    enabled: Boolean(referenceNumber),
    queryKey: ['outage', referenceNumber],
    queryFn: () =>
      IntegrationApi.outagesEndpointsGetSpecificOutage({
        outageNumber: referenceNumber,
      }),
    select: (data) => {
      return {
        ...data,
        energyType: rewriteEnergyType(data.energyType),
      };
    },
  });

  const isNetworkOperator = Boolean(
    specificOutageData?.electricityNetwork?.isOperational ||
      specificOutageData?.gasNetwork?.isOperational
  );

  const replaceText = {
    '{postalCode}': specificOutageData?.address?.postalCode || '',
  };

  if (!isNetworkOperator && specificOutageIsFetched)
    return (
      <OutageNotFound
        notFoundText={setReplaceText(props.notFoundText?.toString() || '', replaceText)}
        notFoundTitle={setReplaceText(props.notFoundTitle?.toString() || '', replaceText)}
      />
    );

  if (!specificOutageIsFetched) return null;
  if (!specificOutageData) return null;

  return (
    <OutageView
      {...props}
      outageData={outageData || {}}
      isSuccess={outageIsSuccess}
      isLoading={outageLoading || specificOutageLoading}
    />
  );
}
